export const contract = { 
    // 97 : {
    //     saleAddress : "0x839a249cd197a1f3181a94fed2da8740d44ce68d",
    //     multicallAddress : "0xa54fe4a3dbd1eb21524cd73754666b7e13b4cb18"
    // },
    56 : {
        saleAddress : "0xddd67f4f846dc0fbf1b8a4f6172730fef6aff5a8",
        multicallAddress : "0x2cc8fe3e04d7b1edaeb42e2e73f78c4cac074116"
    },
    'default':{
        saleAddress : "0xddd67f4f846dc0fbf1b8a4f6172730fef6aff5a8",
        multicallAddress : "0x2cc8fe3e04d7b1edaeb42e2e73f78c4cac074116"
    }

}

